export default __webpack_public_path__ + "static/media/ic_qrcode.b961305f.svg";